import React, { useState } from 'react';
import { Modal, Select, Spin, Button } from 'antd';
import { useGetUnits } from '../../hooks/genericHooks';
import { getAnchoredModalStyle } from './modalPositioning';

// Accept unified dynamic modal props
interface UnitsSelectProps {
  open: boolean;
  value?: any;
  onOk: (value: any) => void;
  onCancel: () => void;
  afterClose?: () => void;
  anchorRect?: DOMRect | null;
  options?: any[];
}

const UnitsSelect: React.FC<UnitsSelectProps> = ({ open, value, onOk, onCancel, afterClose, anchorRect }) => {
  const { data: unitsData, isLoading } = useGetUnits();
  const [selectedId, setSelectedId] = useState<string | number | null>(value ?? null);

  const modalWidth = 520;

  // Keep internal state in sync with prop
  React.useEffect(() => {
    setSelectedId(value ?? null);
  }, [value]);

  const unitsList = Array.isArray(unitsData)
    ? unitsData
    : (unitsData?.data || []);

  return (
    <Modal
      open={open}
      title="Select Unit"
      closable={true}
      getContainer={false}
      centered={!anchorRect}
      style={anchorRect ? getAnchoredModalStyle(anchorRect, { width: modalWidth }) : undefined}
      afterClose={afterClose}
      footer={[
        <Button key="cancel" onClick={onCancel}>Cancel</Button>,
        <Button
          key="ok"
          type="primary"
          onClick={() => {
            const selectedUnit = unitsList.find((unit: any) => unit.id === selectedId);
            if (selectedUnit) {
              // Return only the short abbreviation (symbol) as the selected value
              onOk(selectedUnit.symbol);
            }
          }}
          disabled={!selectedId}
        >
          Select
        </Button>
      ]}
      destroyOnClose
      onCancel={onCancel}
    >
      <Spin spinning={isLoading}>
        <Select
          showSearch
          style={{ width: '100%', borderRadius: 0, background: '#e6f2ff', border: 'none' }}
          placeholder="Select a unit"
          value={selectedId ?? undefined}
          onChange={setSelectedId}
          optionFilterProp="children"
          dropdownStyle={{ borderRadius: 0 }}
          filterOption={(input, option) =>
            String(option?.children).toLowerCase().includes(input.toLowerCase())
          }
        >
          {unitsList.map((unit: any) => (
            <Select.Option
              key={unit.id}
              value={unit.id}
              title={`${unit.name} (${unit.symbol}) - ${unit.category}${unit.description ? ` - ${unit.description}` : ''}`}
            >
              {unit.name} ({unit.symbol}) - {unit.category}{unit.description ? ` - ${unit.description}` : ''}
            </Select.Option>
          ))}
        </Select>
      </Spin>
    </Modal>
  );
};

export default UnitsSelect;
